import firebase from "firebase/app";
import "firebase/firestore";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAup8p36I5pEGK7vilU_F9M2odIjCiI3ug",
    authDomain: "dynamify-cbdc8.firebaseapp.com",
    databaseURL: "https://dynamify-cbdc8.firebaseio.com",
    projectId: "dynamify-cbdc8",
    storageBucket: "dynamify-cbdc8.appspot.com",
    messagingSenderId: "302438952615",
    appId: "1:302438952615:web:b8219835e0ce221b473582"
});

const db = firebaseApp.firestore();


export { db };
